import { render, staticRenderFns } from "./TabSbrHvi.vue?vue&type=template&id=26fae90a&scoped=true&"
import script from "./TabSbrHvi.vue?vue&type=script&lang=js&"
export * from "./TabSbrHvi.vue?vue&type=script&lang=js&"
import style0 from "./TabSbrHvi.vue?vue&type=style&index=0&id=26fae90a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fae90a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAlert,VBtn})
